import { connect } from 'react-redux';
import searchActions from 'src/store/modules/search/actions';

import { ModelsPartsResults } from './ModelsPartsResults';
import { withI18n } from 'react-i18next';

import { analyticsActions } from 'src/analytics/store';

const mapStateToProps = (state: any) => {
  return {
    searchedText: state.search.text,
    results: state.search.results,
    page: state.search.page,
    isLoggedIn: state.signin.success,
    loading: state.search.loading
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onSearchNextPage: () => dispatch(searchActions.searchNextPage()),
  onResetPage: () => dispatch(searchActions.resetPage()),
  fireProductClickEvent: (data: any) =>
    dispatch(analyticsActions.searchResultProductClick(data))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(ModelsPartsResults));

interface IDispatchFromProps {
  onSearchNextPage: () => void;
  onResetPage: () => void;
  fireProductClickEvent: (data: any) => void;
}
